import { targetFroms, linkTypes } from 'json/link-manage'
export let tableLabels = [
  {
    label: '名称',
    value: 'title'
  },
  {
    label: '来源',
    value: 'from_channel'
  },
  {
    label: '类型',
    value: 'object_type'
  },
  {
    label: '生成的链接',
    value: 'trackUrl'
  }
]
// 列表筛选条件
export let filterLabels = [
  {
    label: '来源',
    value: 'from',
    type: 'select',
    options: targetFroms
  },
  {
    label: '类型',
    value: 'objectType',
    type: 'select',
    options: linkTypes
  }
]
